import React from 'react';
import { Link } from 'react-router-dom';
import { PlusCircle } from 'lucide-react';
import { toArray } from '../utils/toArray';


const RecentList = ({ title, items, renderItem, addLink, isLoading = false }) => (
  <div className="bg-pro-dark-surface p-6 rounded-2xl shadow-lg">
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-semibold">{title}</h2>
      <Link
        to={addLink}
        className="flex items-center gap-2 px-3 py-1.5 text-xs bg-pro-dark-accent text-white rounded-full hover:bg-pro-dark-accent-hover transition-colors"
      >
        <PlusCircle size={14} />
        Ajouter
      </Link>
    </div>
    <div className="space-y-2">
      {isLoading ? (
        Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-8 bg-pro-dark-border rounded animate-pulse" />
        ))
      ) : (
        toArray(items).map(renderItem)
      )}
    </div>
  </div>
);

export default RecentList;
